import {ReactElement} from "react";
import {Checkbox} from "antd/lib";
import {Select} from "antd";
import {getClients} from "../../services/ServiceClient";
import {useTranslate} from "@refinedev/core";
import {Custom} from "../../utils/refineUtils";
import IClient from "../../interfaces/IClient";

interface IProps {
    editable?: boolean
    client?: IClient
    index?: number
}

export default function ConfigLAWeb(props: IProps): ReactElement {
    const translate = useTranslate()
    const {clients} = getClients()
    const scenarios: any[] = clients?.find(client => client?.id === 'laweb')?.config.scenarios
    return props?.editable ? <>
        <Custom.Item name={[props.index ?? 0, 'config', 'shared']} label="configClients.laweb.shared"
                     valuePropName="checked">
            <Checkbox>{translate('configClients.laweb.shared')}</Checkbox>
        </Custom.Item>
        <Custom.Item name={[props.index ?? 0, 'config', 'scenario']} label="configClients.laweb.scenario">
            <Select options={scenarios.map(s => ({label: s.name + ' - ' + s.url, value: s.id}))}/>
        </Custom.Item>
    </> : <>
        <Custom.IconInfo icon={null} label="configClients.laweb.shared"
                         value={props.client?.config.shared ? 'Oui' : 'Non'}/>
        <Custom.IconInfo icon={null} label="configClients.laweb.scenario"
                         value={scenarios.find(s => s.id === props.client?.config.scenario).name}/>
    </>
}